import React, { Component } from 'react';
import { connect } from 'react-redux';
import { selectItem, deselectItem } from '../../../actions/setting/teamblog';

import ItemCheckbox from "../../common/EntryItemCheckbox";

@connect(state => ({
}), dispatch => ({
    handleSelectItem: (id) => {
        dispatch(selectItem(id))
    },

    handleDeselectItem: (id) => {
        dispatch(deselectItem(id))
    },
    dispatch
}))
class TeamBlogListItem extends Component {

    constructor(props) {
        super(props);

        this.handleSelect = this.handleSelect.bind(this);
    }

    handleSelect(e) {
        const { item, handleSelectItem, handleDeselectItem } = this.props;

        if (item.selected) {
            handleDeselectItem(item.id)
        } else {
            handleSelectItem(item.id)
        }
    }

    render() {

        const { item } = this.props;

        return (<li>
                    <ItemCheckbox item={item} handleSelect={this.handleSelect} />
                    <span className="post_etc">
                        { this.renderRole(item)}
                    </span>
                    <div className="post_cont">
                        <span className="wrap_thumb">
                            <img src={item.userImage} width="36" height="36" className="thumb_img" alt=""/>
                        </span>
                        <strong className="tit_post">
                            <span className="link_cont">{item.name}</span>
                        </strong>
                    </div>
                    <span className="post_etc post_count">
                        작성글<span className="txt_etc">{item.entryCount}</span>
                    </span>
                    <span className="post_etc post_date"> 가입<span className="txt_etc">{item.created}.</span></span>
                </li>
            );
    }

    renderRole(item) {
        if(item.role === 'owner')
            return '소유자';
        else if(item.role === 'manager')
            return '관리자';
        else if(item.role === 'editor')
            return '편집자';
        else if(item.role === 'writer')
            return '필자';
        else
            return null;
    }
}

export default TeamBlogListItem;
